import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { accountService} from "../../_services";
import { util, config } from "../../_helpers";
import * as Yup from "yup";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-responsive-list'
import 'react-responsive-list/assets/index.css'
import { toast } from "../../_components/Toast";
function Members(props) {
  let urlUsr = window.document.location.pathname.split('view/')[1];
  const user = props.user || accountService.userValue;

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    phone: "",
    password: "",
    mpin: "",
    confirmPassword: "",
    acceptTerms: true,
    isIAM: true,
    parentUser: urlUsr?urlUsr:user.user.sub,
  };

 
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    email: Yup.string().email("Email is invalid"),
    phone: Yup.string()
      .matches(phoneRegExp, "Phone is invalid")
      .required("Phone is required"),
    role: Yup.string().required("Role is required"),
    mpin: Yup.string()
      .required("MPIN field required")
      .min(4, "Must be exactly 4 digits")
      .max(4, "Must be exactly 4 digits"),
  });
  const [isMember, setIsMember] = useState(false);
  const [membersData, setMembersData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);


 useEffect(() => {
    getRolesData();
    
  }, []);

  const handleMember = async () => {
    setIsLoadingRoles(true);
    try {
     let roles= await getRolesData();
      console.log('----------------------',roles);
      // After roles are loaded, show the modal
      props.showModalContent(addNewMember(false,roles), 'Add New Member');
      props.showModal(true);
      setIsMember(true);
    } catch (error) {
      console.error("Error loading roles:", error);
      toast.error("Error: "+ error);
    } finally {
      setIsLoadingRoles(false);
    }
  };
  
  function memberData(roles) {
    accountService.getMember(user.id)
      .then(async (res) => {
        if (res && Array.isArray(res)) {
          // filter is synchronous, so no await needed here
          let mems = res.filter(user => user.isIAM);

          // map with async callback returns array of Promises, so await Promise.all here
          mems = await Promise.all(
            mems.map(async m => {
          
              const foundRole = (roles||roleData).find(rl => rl.id == m.role);
            
              m.roleName = foundRole ? foundRole.roleName : "Role Not Found";
              return m;
            })
          );
          setMembersData(mems);
        } else {
          console.error("Invalid members data format:", res);
          setMembersData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching members:", error);
        setMembersData([]);
      });  

    }
 async function getRolesData() {
    
   const rolesList = await accountService.getRoles(user.id)
      .then((res) => {
        if (res && Array.isArray(res)) {
          console.log('got roles lists', res);
          setRoleData(res);

        } else {
          console.error("Invalid members data format:", res);
          setRoleData([]);
        }
          memberData(res);
         return res;
      })
      .catch((error) => {
        console.error("Error fetching members:", error);
        setRoleData([]);
          //memberData();
        return roleData;
      });

      return rolesList;
 
  }

 

  const postSuccess = (props) => {
    setIsMember(false);
    memberData();
    props.showModal(false);
  }

  function onSubmit(fields, { resetForm  }) {
    //setStatus();
    if(!fields.id){
    accountService
      .create(fields)
      .then((res) => {
         postSuccess(props);
      })
      .catch((error) => {
        //setSubmitting(false);
        console.log(error);
        toast.error("Error: "+ error);
      });
    }else{
    accountService
      .update(fields.id,fields)
      .then((res) => {
         postSuccess(props);
      })
      .catch((error) => {
         toast.error("Error: "+ error);
      });
    }
    resetForm();
  }

  const handleMangeMem = () => {
    setIsPermission(false);
  };  

  const editMember = (id) => {
      try {
         // Fetch roles when edit member popup is opened
         getRolesData();
        let selectedMember = membersData.filter(m => m.id == id);
       return addNewMember(selectedMember[0]);
      } catch (error) {
        console.error("Error loading roles for edit:", error);
        toast.error("Failed to load roles. Please try again.");
        return null;
      }
  }

  const addNewMember = (selMember, newRoleList) => {
    return (
      <div className="modern-member-form-container">

        <Formik
          enableReinitialize
          initialValues={selMember || initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ errors, touched, isSubmitting, resetForm }) => (
            <Form className="modern-member-form">
              <div className="form-content">
                {/* Form Fields Container */}
                <div className="form-fields-container">
                  {/* Row 1: Name and Role */}
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        First Name <span className="required">*</span>
                      </label>
                      <Field
                        name="firstName"
                        type="text"
                        className={`form-input ${
                          errors.firstName && touched.firstName ? "error" : ""
                        }`}
                        placeholder="Enter first name"
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="error-message"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Role <span className="required">*</span>
                      </label>
                      <Field
                        as="select"
                        name="role"
                        className={`form-select ${
                          errors.role && touched.role ? "error" : ""
                        }`}
                        
                      >
                        <option value="" disabled>
                          Select Role
                        </option>
                        {newRoleList && newRoleList.length > 0 ? (
                          newRoleList.map((r, index) => (
                            <option key={r.id || index} value={r.id}>
                              {r.roleName}
                            </option>
                          ))
                        ) : (
                          <option disabled>No roles available</option>
                        )}
                        {!newRoleList && roleData && roleData.length > 0 ? (
                          roleData.map((r, index) => (
                            <option key={r.id || index} value={r.id}>
                              {r.roleName}
                            </option>
                          ))
                        ) : 
                          !newRoleList?<option disabled>No roles available</option>:""
                        }
                      </Field>
                      <ErrorMessage
                        name="role"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>

                  {/* Row 2: Email and Phone */}
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        Email Address <span className="required">*</span>
                      </label>
                      <Field
                        name="email"
                        type="email"
                        className={`form-input ${
                          errors.email && touched.email ? "error" : ""
                        }`}
                        placeholder="Enter email address"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error-message"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Phone Number <span className="required">*</span>
                      </label>
                      <Field
                        name="phone"
                        type="tel"
                        className={`form-input ${
                          errors.phone && touched.phone ? "error" : ""
                        }`}
                        placeholder="Enter phone number"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>

                  {/* Row 3: MPIN (single column, centered) */}
                  <div className="form-row">
                    <div className="form-group form-group-single">
                      <label className="form-label">
                        MPIN <span className="required">*</span>
                      </label>
                      <Field
                        name="mpin"
                        type="number"
                        min={1000}
                        max={9999}
                        className={`form-input ${
                          errors.mpin && touched.mpin ? "error" : ""
                        }`}
                        placeholder="Enter 4-digit MPIN"
                      />
                      <ErrorMessage
                        name="mpin"
                        component="div"
                        className="error-message"
                      />
                      <div className="form-help">
                        4-digit Mobile PIN for secure access
                      </div>
                    </div>
                  </div>

                  {/* Row 4: Password and Confirm Password */}
                  {!selMember && <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        Password <span className="required">*</span>
                      </label>
                      <Field
                        name="password"
                        type="password"
                        className={`form-input ${
                          errors.password && touched.password ? "error" : ""
                        }`}
                        placeholder="Enter password"
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="error-message"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Confirm Password <span className="required">*</span>
                      </label>
                      <Field
                        name="confirmPassword"
                        type="password"
                        className={`form-input ${
                          errors.confirmPassword && touched.confirmPassword ? "error" : ""
                        }`}
                        placeholder="Confirm password"
                      />
                      <ErrorMessage
                        name="confirmPassword"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>}
                </div>
              </div>
              {/* Form Actions */}
                <div className="footer-btn-holder">
                <button
                  onClick={()=>{resetForm();
                    setIsMember(false);
                    props.showModal(false);}}
                  className="btn-custom-cancel"
                >
                  Cancel
                </button>
                <button
                  disabled={isSubmitting}
                  className="btn-custom-primary"
                >
                  {isSubmitting ? (
                  <>
                <div className="subscription-loading-spinner"></div>
                Saving...
                 </>
                  ) : (
              <>
                {selMember ? 'Update Member' : 'Create Member'}
              </>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>

        <style jsx="true">{`
            .form-group{
              margin: 10px;
            }
        `}</style>
      </div>
    );
  }

  // New function to handle member deletion
  const handleDeleteClick = (memberId) => {
    setShowConfirm(true);
    setSelectedMemberId(memberId);
  };

  const handleConfirm = () => {
    deleteMember(selectedMemberId);
    setShowConfirm(false);
  };
  const deleteMember = (memberId) => {
    console.log('Deleting member with ID:', memberId);
    accountService.delete(memberId)
        .then(() => {
          memberData();
          toast.success('Member deleted successfully');
        })
        .catch((error) => {
          console.error('Error deleting member:', error);
          toast.error('Failed to delete member: ' + (error.message || error));
        });
  };

  return (
    <div >
      <div className="">
        <div className=""> 
          <div className="personal-details-header">
            <h4 className="personal-details-title">
              Members
            </h4>
            <button
              onClick={handleMember}
              disabled={isLoadingRoles}
              className="reset-password-btn"
              style={{
                padding:"8px 16px",
                fontSize:"14px",
              }}
            >
              {isLoadingRoles ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                  Loading...
                </>
              ) : (
                <>
                  <i class="bi bi-plus-square" style={{ marginRight: "6px" }}></i>
                  {"Add New Member"}
                </>
              )}
            </button>
          </div>
          
            <div className="members-list-container">
              <div
                className={ "members-table-desktop"}
              >
                <Table
                  cellPadding="5px"
                  cellSpacing="3px"
                  style={{ width: "100%", marginTop: "10px" }}
                >
                  <Thead>
                    <Tr>
                      <Th style={{ width: "20%" }}>Name</Th>
                      <Th style={{ width: "25%" }}>Email</Th>
                      <Th style={{ width: "20%" }}>Role</Th>
                      <Th style={{ width:  "15%", display:"table-cell" }}>Phone</Th>
                      <Th style={{ width:"20%", textAlign: "center" }}>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {membersData && membersData.length > 0
                      ? membersData.map((mem, index) => {
                        console.log('=====',mem);
                          // let role = roleData.find(rl=> rl.id === mem.role)
                          // console.log(role);
                          // console.log(rolem);
                          return (
                            <Tr key={mem.id || index}>
                              <Td>
                                <span
                                  style={{
                                    fontWeight: "500",
                                    color: "#1f2937",
                                    fontSize: "15px",
                                    wordBreak: "normal",
                                  }}
                                >
                                  {mem.firstName || 'N/A'}
                                 
                                </span>
                              </Td>
                              <Td>
                                <span style={{ fontSize: isMobile ? "13px" : "14px" }}>
                                  {mem.email || 'N/A'}
                                </span>
                              </Td>
                              <Td>
                                <span
                                  style={{
                                    fontSize: "13px",
                                    padding: "4px 8px",
                                    backgroundColor: "#f3f4f6",
                                    borderRadius: "4px",
                                    color: "#374151",
                                    fontWeight: "500"
                                  }}
                                >
                                  {mem.roleName || "No Role"}
                                </span>
                              </Td>
                              <Td style={{ display: "table-cell" }}>
                                <span style={{ fontSize: "14px" }}>
                                  {mem.phone || 'N/A'}
                                </span>
                              </Td>
                              <Td>
                                <div
                                  className={`role-actions""
                                  }`}
                                  style={{ justifyContent: "flex-end" }}
                                >
                                 <i style={{color:"red", cursor:"pointer", marginRight:"20px"}} class="bi bi-trash" onClick={() => handleDeleteClick(mem.id)}></i>

                                 <i style={{ cursor:"pointer", marginRight:"20px"}} class="bi bi-pencil-fill"    onClick={async () => { 
                                      const editForm = await editMember(mem.id);
                                      if (editForm) {
                                        props.showModalContent(editForm, 'Edit Member');
                                        props.showModal(true);
                                      }
                                    }}></i>
                                  
                                </div>
                              </Td>
                            </Tr>
                          );
                        })
                      : <Tr><Td colSpan={"5"} style={{textAlign: 'center', padding: '20px', color: '#666'}}>No members found</Td></Tr>}
                  </Tbody>
                </Table>
              </div>
    
          </div>
        </div>
      </div>

      {showConfirm && (
        <div className="dialog-overlay">
          <div className="dialog">
            <h3>Warning!!</h3>
            <p>Are you sure you want to delete this member?</p>
            <div>
              <button className="confirm" onClick={handleConfirm}>Yes</button>
              <button className="cancel" onClick={() => setShowConfirm(false)}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export { Members };
